export default {
  FACEBOOK: "FACEBOOK",
  TWITTER: "TWITTER",
  YOUTUBE: "YOUTUBE",
};
